import React from "react";

const DealMonitoringList = React.lazy(() => import('src/pages/deal_monitoring/DealMonitoringList'));
const ViewDealMonitoring = React.lazy(() => import('src/pages/deal_monitoring/ViewDealMonitoring'));

const routes = [
    { path: '/dashboard/deal-monitoring-list/:param', withParam: true, exact: true, name: "", element: ViewDealMonitoring },
    { path: '/dashboard/deal-monitoring-list', name: 'Deal Monitoring', element: DealMonitoringList },
];

export default routes;
